
import ShowDevicePositionModalComponent from '@/components/Modals/Hiv/ShowDevicePositionModal/ShowDevicePositionModalComponent';
export default ShowDevicePositionModalComponent;
